import { useQuery } from '@apollo/client';
import { graphql } from '../gql';
import { useMemo } from 'react';
import {
  getPaginatedNodes,
  getPaginationTotalResults,
  toPagination,
} from './utils';
import { DomainFilterInput, PaginationSort } from '../gql/graphql';

export const GET_DOMAINS = graphql(`
  query getDomainList(
    $pagination: PaginationRequest
    $filters: DomainFilterInput
    $sort: PaginationSort
  ) {
    domains(pagination: $pagination, filters: $filters, sort: $sort) {
      pageInfo {
        totalResults
        pageNumber
        pageSize
        hasNextPage
        hasPreviousPage
      }
      edges {
        node {
          uuid
          domain
          dkim
          spf
          subDomains {
            edges {
              cursor
              node {
                uuid
                dmarc
                name
              }
            }
          }
        }
      }
    }
  }
`);
export interface IUseDomainListQueryArg {
  pageNumber: number;
  pageSize: number;
  sort?: PaginationSort;
  filters?: DomainFilterInput;
}
export function useDomainListQuery({
  pageNumber,
  pageSize,
  sort,
  filters,
}: IUseDomainListQueryArg) {
  const { loading, data, error } = useQuery(GET_DOMAINS, {
    variables: {
      pagination: toPagination(pageNumber, pageSize),
      sort,
      filters: {
        ...filters,
      },
    },
  });
  const { domains, totalDomains } = useMemo(() => {
    if (loading) {
      return {
        domains: [],
        totalDomains: 0,
      };
    }
    return {
      domains: getPaginatedNodes(data?.domains),
      totalDomains: getPaginationTotalResults(data?.domains) ?? 0,
    };
  }, [data, loading]);

  return {
    loading,
    error,
    data,
    domains,
    totalDomains,
  };
}
